export default __webpack_public_path__ + "static/media/a019-2.d4044ad8.svg";